import { render, staticRenderFns } from "./IcoHoldHands.vue?vue&type=template&id=0be49aa8"
import script from "./IcoHoldHands.vue?vue&type=script&lang=js"
export * from "./IcoHoldHands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports